module.exports = __webpack_public_path__ + "static/media/folder.10bab3b4.svg";